import { render } from "./BlogComp.vue?vue&type=template&id=7353aec9&scoped=true"
import script from "./BlogComp.vue?vue&type=script&lang=js"
export * from "./BlogComp.vue?vue&type=script&lang=js"

import "./BlogComp.vue?vue&type=style&index=0&id=7353aec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7353aec9"]])

export default __exports__